/* eslint-disable no-extend-native */
// String.prototype.replaceAll polyfill for Samsung Internet < 12 and Chrome < 85.
// @hcaptcha/loader uses replaceAll and crashes without this on old browsers.
if (typeof String.prototype.replaceAll === "undefined") {
  String.prototype.replaceAll = function(search, replace) {
    return this.split(search).join(replace);
  };
}
